import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORMS]: {
		url: '/company/:companyId/works_productivity_norms/',
	},

	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].GET_WORKS_PRODUCTIVITY_NORM]: {
		url: '/company/:companyId/works_productivity_norms/:worksProductivityNormId/',
	},
	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].CREATE_WORKS_PRODUCTIVITY_NORM]: {
		url: '/company/:companyId/works_productivity_norms/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PUT_WORKS_PRODUCTIVITY_NORM]: {
		url: '/company/:companyId/works_productivity_norms/:worksProductivityNormId/',
		requestOptions: {
			method: 'PUT',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].PATCH_WORKS_PRODUCTIVITY_NORM]: {
		url: '/company/:companyId/works_productivity_norms/:worksProductivityNormId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
	[ModulesConfigMap[ModulesMap.WORKS_PRODUCTIVITY_NORMS].DELETE_WORKS_PRODUCTIVITY_NORM]: {
		url: '/company/:companyId/works_productivity_norms/:worksProductivityNormId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
